import { applyOverrides, counterpartyAgentCard } from '../../../shared';

export const buyersAgentCard = applyOverrides(counterpartyAgentCard, {
  id: 'buySideContacts.buyersAgent',
  innerTitle: "Tenant's Agent x",
  outerTitle: "Tenant's Agents",
  addText: "Tenant's Agent",
  addableTitle: "Tenant's Agent x",
});
